import {
    AfterViewInit,
    Component,
    OnDestroy,
} from '@angular/core';
import {ProjectManagementService} from 'app/services/project-management.service';
import {DataService} from "app/services/data.service";
import {FrontEndService} from "app/services/front-end.service";
import {LogService} from "app/services/log.service";
import {Observable} from "rxjs/Rx";
import {StateService, Transition} from '@uirouter/angular';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})

export class TimelineComponent implements AfterViewInit, OnDestroy {

    timer = Observable.timer(0, 30000);
    timer_subscription: any;
    // This is required to maintain the list when moving b/w states.
    activity_list = [];
    fip_id = null;
    toggled = false;
    last_request;
    loading = false;
    firstActivityLoaded = false;
    noMoreActivity = false;
    off_set = 0;
    card_loading = false;
    fetch_more = true;

    constructor(
        private project_management_service: ProjectManagementService,
        public data_service: DataService,
        public front_end_service:FrontEndService,
        private transition: Transition,
        private stateService: StateService,
        private logService: LogService
    ) {
    }

    ngAfterViewInit() {
        this.setActivityTimer();

        if(this.data_service.current_project_changed) {

            this.newThisProjectActivity();
            this.data_service.current_project_changed = false;
        }
    }

    ngOnDestroy() {
        this.timer_subscription.unsubscribe();
    }

    setActivityTimer() {
        this.timer_subscription = this.timer.subscribe(() => {
            if(this.data_service.for_all_activity) {
                this.fip_id = null;
            } else {
                this.fip_id = this.data_service.selected_project;
            }

            this.activity_get(this.data_service.activity_limit, 0);
        });
    }

    activity_get(
        limit ,
        offset,
        continue_fetch = false,
    ) {

        const forAllProject = this.data_service.for_all_activity;
        const fip = this.fip_id;

        if(this.data_service.activity_waiting_for_response && !continue_fetch) {
            // Stop further http requests until last req. gives ans
            this.logService.printLog("activity waiting for response.");
        } else {
            this.data_service.activity_waiting_for_response = true;

            if(!this.firstActivityLoaded) {
                this.loading = true;
            }

            this.last_request = this.project_management_service.activity_get(limit, offset, (resp) => {
                this.loading = false;
                this.firstActivityLoaded = true;
                this.data_service.activity_waiting_for_response = false;
                this.logService.printLog("Timeline Response - ", resp.data);

                if (resp.status === true) {

                    if(this.toggled) {
                        // if toggle key was pressed, then clear old data
                        this.toggled = false;
                        this.data_service.activity_list = [];
                        this.activity_list = [];
                    }

                    this.logService.printLog("Got Project Activity controller callback");
                    this.data_service.activity_count = resp.count; // commented to implement scroll fetch

                    for (let i = 0; i < resp.data.length; i++) {

                        const test_proj = this.data_service.get_array_details(this.data_service.activity_list, "id", resp.data[i].id);

                        if (test_proj === undefined) {
                            // If object is being inserted then only sort.
                            this.data_service.activity_list.push(resp.data[i]);

                            // sort array
                            this.data_service.activity_list = this.data_service.sort_this(
                                this.data_service.activity_list,
                                "id"
                            );
                        }
                    }

                    // give value to this view's variable.
                    this.activity_list = this.data_service.activity_list;

                    if(continue_fetch) {
                        this.card_loading = false;
                    }
                } else {
                    this.logService.printLog("Failed Project Activity controller callback");
                }
            }, forAllProject, fip);
        }
    }

    toggleLabel() {
        if (this.last_request !== undefined) {
            this.last_request.unsubscribe();
        }
        if (this.timer_subscription !== undefined) {
            this.timer_subscription.unsubscribe();
        }
        this.off_set = 0;
        this.data_service.activity_waiting_for_response = false;
        this.data_service.activity_count = 10;
        this.firstActivityLoaded = false;

        setTimeout(() => {
            this.toggled = true;
            this.setActivityTimer();
        }, 200);
    }

    keys(object) {
        return object.keys();
    }

    newThisProjectActivity() {
        this.toggleLabel();
        this.data_service.activity_list = this.data_service.sort_this(
            this.data_service.activity_list,
            this.transition.params().project_id
        );

        // give value to this view's variable.
        this.activity_list = this.data_service.activity_list;
    }

    /**
     * Change state according to the activity type
     * @param activity
     */
    activityClicked(activity) {
        this.logService.printLog("Sel activity - " + JSON.stringify(activity));
        switch(activity.activity_type) {
            case "0":
            case "7":
                this.stateService.go("singlePost", { project_id: activity.project.fip_id, post_id: activity.post_id });
                break;
            case "1":
                this.stateService.go("projectDetails", { project_id: activity.project.fip_id });
                break;
            case "2":
                this.stateService.go("projectDetails", { project_id: activity.project.fip_id });
                break;
            case "3":
                this.stateService.go("projectDetails", { project_id: activity.project.fip_id });
                break;
            case "4":
                this.stateService.go("projectUsers", { project_id: activity.project.fip_id });
                break;
            case "5":
                this.stateService.go("projectDetails", { project_id: activity.project.fip_id });
                break;
            case "6":
            case "8":
                this.stateService.go("projectAttachments", { project_id: activity.project.fip_id });
                break;
            case "9":
                this.stateService.go("projectEvaluationTab", { project_id: activity.project.fip_id });
                break;
            default:
                this.stateService.go("project", { project_id: activity.project.fip_id });
        }
    }

    onScroll() {
        this.logService.printLog("fetch_more" + this.fetch_more);
        if(this.data_service.activity_count > (this.off_set + 10) ) {
            this.card_loading =true;
            this.fetch_more =true;
        } else {
            this.card_loading =false;
            this.fetch_more =false;
            this.noMoreActivity = true;
        }

        if(this.fetch_more) {
            this.logService.printLog("this.data_service.activity_count" + this.data_service.activity_count);
            this.logService.printLog("this.off_set" + this.off_set);

            this.off_set += 10;

            if(this.data_service.for_all_activity) {
                this.fip_id = null;
                this.activity_get(this.data_service.activity_limit, this.off_set, true);
                this.logService.printLog('If Offset :' + this.off_set);
            } else {
                this.fip_id = this.data_service.selected_project;
                this.activity_get(this.data_service.activity_limit, this.off_set, true);
                this.logService.printLog('Else Offset :' + this.off_set);
            }
        }
    }

    openProfile(id) {
        if (this.data_service.userProfileModuleEnabled) {
            this.stateService.go("profileDetails", {user_id: id});
        }
    }
}
